import prestashop from 'prestashop';
import $ from 'cash-dom';

prestashop.blockcart = prestashop.blockcart || {};


prestashop.blockcart.showModal = (html) => {

  function getBlockCartModal() {
    return $('#blockcart-modal');
  }

  let $blockCartModal = getBlockCartModal();

  if ($blockCartModal.length) {
    $blockCartModal.remove();
  }

  $('body').append(html);

  $blockCartModal = getBlockCartModal();

  let backdrop= document.querySelector('.modal-backdrop');
  
  if(!backdrop){
    backdrop = document.createElement('div');
    backdrop.classList.add('modal-backdrop','fade');
    document.body.appendChild(backdrop);
  }

  backdrop.classList.add('in');
  let modal =document.querySelector('#blockcart-modal');

  if(!modal) return;

  modal.style.display='block';
  modal.classList.add('in','show');

  function closeModal(){
    modal.style.display='none';
    console.log('close modal');
    document.body.removeChild(modal);
    document.body.removeChild(document.querySelector('.modal-backdrop'));
  }

  modal.querySelectorAll('[data-dismiss]').forEach(a=>a.addEventListener('click',()=>{
    closeModal();
  }));

 function clickWindow(event){
    if(event.target==modal){
        closeModal();
        window.removeEventListener('click',clickWindow);
    }
    return true;
  }
  window.addEventListener('click', clickWindow, false);

  return true;
  $blockCartModal.modal('show').on('hidden.bs.modal', (event) => {
    prestashop.emit('updateProduct', {
      reason: event.currentTarget.dataset,
      event,
    });
  });
};

/*
const $body = $('body');
// promo code core
const $timeoutEffect = 400;

$body.on('hidden.bs.collapse', '#promo-code', () => {
//   $('.display-promo').show($timeoutEffect);
//   $('#promo-code').style.display='none';
});

$body.on('click', '.promo-code-button', (event) => {
  event.preventDefault();

//   $('#promo-code').collapse('toggle');
  $('#promo-code').style.display='block';
});

$body.on('click', '.display-promo', (event) => {
  $(event.currentTarget).hide($timeoutEffect);
});
*/